import React, {Component} from 'react';

export default class ElectricityView extends Component {
  render() {
    return (
      <section className="container tip-flex">
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Quick Tips</h2>
            <ul>
                <li className="tip light-tip"><p>Turn down the Thermostat. Ideally, keep your home heated to 68 degrees Fahrenheit during the day and 60 at night. Use extra blankets and sweaters instead of turning up the heat. Likewise, in the summer, dress cool to save on air conditioning costs and energy.</p></li>
                <li><p className="tip light-tip">Clean or replace filters regularly. Be sure to check the furnace, air conditioner and heat pump filters regularly. By cleaning your heating, ventilation and air-conditioning equipment, your units will last longer, avoid costly downtime and improve indoor air quality.</p></li>
                <li><p className="tip light-tip">Turn unused appliances and equipment off. Turn off equipment and lights at night and on the weekend, unplug appliances when they are not in use.</p></li>
            </ul>
          </div>
        </div>
        <div className="tip-outline">
          <div className="guide-section">
            <h2>Resources</h2>
            <ul>
              <li className="resource-outline">
                <a href="https://www.epa.gov/energy/learn-about-energy-and-its-impact-environment" target="_blank" rel="noreferrer" >
                <div className="resource-container">
                  <div className="flex-item">
                    <h4>Learn about Energy and its Impact on the Environment</h4>
                    <p>Clean energy includes renewable energy, energy efficiency and efficient combined heat and power...</p>
                  </div>
                    <div className="flex-item">
                      <img className="resource-image" src="/img/electricity-site-1.png" alt="graph of electricity usage"></img>
                    </div>
                  </div>
                </a>
              </li>
              <li className="resource-outline">
              <a href="https://www.epa.gov/energy" target="_blank" rel="noreferrer" >
                <div className="resource-container">
                  <div className="flex-item"><h4>Energy and the Environment</h4>
                  <p>Learn, Act, Resources...</p></div>
                  <div className="flex-item">
                    <img className="resource-image" src='/img/electricity-site-2.png' alt="windmills"></img>
                  </div>
                </div>
                </a>
              </li>
              <li className="resource-outline">
              <a href="https://www.epa.gov/energy/clean-energy-programs" target="_blank" rel="noreferrer" >
                <div className="resource-container">
                  <div className="flex-item"><h4>Clean Energy Programs</h4>
                  <p>EPA’s renewable energy and energy efficiency programs are designed to help energy consumers in all sectors, state policy makers, and energy providers...</p></div>
                  <div className="flex-item">
                    <img className="resource-image" src='/img/electricity-site-3.png' alt="Agstar logo"></img>
                  </div>
                </div>
                </a>
              </li>
            </ul>
          </div>
          
        </div>
      </section>
    )
  }
}